import {OnInit, AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef} from "@angular/core";
import {AppService} from "@api";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {PeriodoEvaluacion} from "@modelo/proceso/periodoevaluacion.model";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {AlertaEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {PreparacionEvaluacionPreguntaGeneral} from "./preparacionevaluaciopregunta/preparacionevaluaciopregunta.component";
import {PlantillaPreguntaFormComponent} from "../plantillapregunta/plantillapreguntaForm.component";

@Component({
    selector: 'preparacionplantillaevaluacion',
    templateUrl: './preparacionevaluacionForm.component.html',
    styleUrls: ['./preparacionevaluacion.component.scss']
})

export class PreparacionEvaluacionFormComponent implements OnInit, AfterViewInit {
    entidad: PeriodoEvaluacion;
    @Input() accion!: {accionid: number, accion: string};
    @Input() entidadperiodo!: any;
    @Output() output = new EventEmitter();

    DataPlantillaTemporal: Array<any>;
    DataPlantilla: Array<any>;
    DataPeriodoPorPlantilla: Array<any>;
    consulta!: boolean;
    MostrarAsignados: boolean;
    colaborador: any;
    DataPuestos: Array<any>

    listatemporar: any[];
    selectedRows: any[];
    selectedRowsPuesto: any[];
    public errorActivo!: boolean;
    cambio: boolean = false;
    ver: boolean = false;

    @ViewChild("plantillaFormulario", {read: ViewContainerRef}) plantillaFormulario!: ViewContainerRef;
    @ViewChild("preparacionevaluacionPregunta", {read: ViewContainerRef}) preparacionevaluacionPregunta!: ViewContainerRef;

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.entidad = new PeriodoEvaluacion();

        this.DataPlantilla = [];
        this.DataPeriodoPorPlantilla = [];
        this.DataPlantillaTemporal = [];
        this.DataPuestos = [];

        this.selectedRows = [];
        this.selectedRowsPuesto = [];
        this.listatemporar = [];

        this.MostrarAsignados = false;
    }

    ngOnInit() {
        this.entidad = new PeriodoEvaluacion(this.entidadperiodo);
        this.entidad.fechainicioperiodo = this.formatDate(this.entidadperiodo.fechainicioperiodo)
        this.entidad.fechainicioacuerdos = this.formatDate(this.entidadperiodo.fechainicioacuerdos)
        this.entidad.fechafinacuerdos = this.formatDate(this.entidadperiodo.fechafinacuerdos)
    }

    ngAfterViewInit() {
        if (this.accion.accionid == 2 && this.sistemaService.permisos.evaluador) {
            this.SetPuestoSinFiltro();
        }
        else if (this.accion.accionid == 2 && !this.sistemaService.permisos.evaluador) {
            this.SetPuestoSuperior();
        }
        else if (this.accion.accionid == 1 && this.sistemaService.permisos.evaluador) {
            this.SetDepartamento();
        }
        else if (this.accion.accionid == 1 && !this.sistemaService.permisos.evaluador) {
            this.SetDepartamentoColaborador();

        }
    }

    onEditorPreparing(e: any) {
        if (e.dataField === 'selected' && e.parentType === 'dataRow') {
            e.editorOptions = {
                value: false
            }
        }
    }

    SetPeriodoPorPlantilla() {
        this.appService.Get("planeacion/preparacionevaluacion/preparacion/plantilla/" + this.entidadperiodo.periodoevaluacionid).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                for (let valor of res.data) {
                    this.DataPeriodoPorPlantilla.push(valor);
                    this.selectedRows.push(valor.plantillaid);
                }
            }
        });
    }

    SetDepartamentoColaborador() {
        this.appService.Get("configuracionrh/departamento/usuario/").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                for (let valor of res.data) {
                    this.listatemporar.push(valor.departamentoid)
                }
                this.SetPlantillas(this.listatemporar);
            }
        })
    }

    SetDepartamento() {
        this.appService.Post("configuracionrh/departamento/buscar", {}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                for (let valor of res.data) {
                    this.listatemporar.push(valor.departamentoid)
                }
                this.SetPlantillas(this.listatemporar)
            }
        })
    }

    SetPlantillas(departamento: any[]) {
        this.appService.Post("planeacion/preparacionevaluacion/plantillas/buscar", {"departamentos": departamento,"entidad":this.entidadperiodo}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.DataPlantillaTemporal = res.data;
                this.DataPlantilla = res.data;
                this.SetPeriodoPorPlantilla();
            }
        })
    }

    SetPuestoSuperior() {
        this.appService.Post("planeacion/preparacionevaluacion/preparacion/puesto", {"puesto": 1, "periodoevaluacionid": this.entidadperiodo.periodoevaluacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.DataPuestos = res.data;
            }
        })
    }

    SetPuestoSinFiltro() {
        this.appService.Post("planeacion/preparacionevaluacion/preparacion/puesto", {"puesto": 0, "periodoevaluacionid": this.entidadperiodo.periodoevaluacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.DataPuestos = res.data
            }
        })
    }

    CambiarInfoTabla(e: boolean) {
        if (e) {
            this.DataPlantilla = this.DataPeriodoPorPlantilla
        } else {
            this.DataPlantilla = this.DataPlantillaTemporal
        }
    }

    Formulario(entidadplantilla: any[]) {
        this.consulta = true;
        this.plantillaFormulario.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(PlantillaPreguntaFormComponent);
        var ref: ComponentRef<any> = this.plantillaFormulario.createComponent(factory);
        ref.instance.accion = {accionid: 1, accion: "Ver plantilla de preguntas"};
        ref.instance.entidadplantilla = entidadplantilla;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }

    VerPreguntasParaAsignar(cell: number, departamentoid: number) {
        this.consulta = true;
        this.preparacionevaluacionPregunta.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(PreparacionEvaluacionPreguntaGeneral);
        var ref: ComponentRef<any> = this.plantillaFormulario.createComponent(factory);
        ref.instance.idpuesto = cell;
        ref.instance.idperiodoevaluacion = this.entidadperiodo.periodoevaluacionid;
        ref.instance.iddepartamento = departamentoid;
        ref.instance.accion = {accionid: 1, accion: "Asignar preguntas"}
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {
                if (this.accion.accionid == 2 && this.sistemaService.permisos.evaluador) {
                    this.SetPuestoSinFiltro();
                }
                else if (this.accion.accionid == 2 && !this.sistemaService.permisos.evaluador) {
                    this.SetPuestoSuperior();
                }
                else if (this.accion.accionid == 1 && this.sistemaService.permisos.evaluador) {
                    this.SetDepartamento();
                }
                else if (this.accion.accionid == 1 && !this.sistemaService.permisos.evaluador) {
                    this.SetDepartamentoColaborador();

                }
            }
        });
    }

    Guardar() {
        if (this.accion.accionid == 1) {
            let periodoporplantilla = []
            let info = {}
            if (this.selectedRows.length > 0) {
                for (let val of this.selectedRows) {
                    info = {'periodoevaluacionid': this.entidadperiodo.periodoevaluacionid, 'plantillaid': val}
                    periodoporplantilla.push(info);
                }
                let infoguardar = {'periodoevaluacionid': this.entidadperiodo.periodoevaluacionid, 'periodoporplantillas': periodoporplantilla}
                this.appService.Post("planeacion/preparacionevaluacion", infoguardar).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.cambio = true;
                        this.Salir();
                    }
                })
            } else {
                this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar mínimo una plantilla para guardar");
            }
        } else {

        }
    }

    formatDate(date: string) {
        let valor = date.split("/")
        let fecha = valor[2] + "-" + valor[1] + "-" + valor[0];
        return fecha;
    }

    Salir() {
        this.output.next(this.cambio);
    }


}